import { render, staticRenderFns } from "./InfoEmpresa.vue?vue&type=template&id=e54cac1e&scoped=true&"
import script from "./InfoEmpresa.vue?vue&type=script&lang=js&"
export * from "./InfoEmpresa.vue?vue&type=script&lang=js&"
import style0 from "./InfoEmpresa.vue?vue&type=style&index=0&id=e54cac1e&rel=stylesheet%2Fscss&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e54cac1e",
  null
  
)

export default component.exports